import { BBookingPaymentStatusEnum } from '@/types/backend';
import { FGA4ConfirmBookingErrorTypeEnum, FGTMEventEnum } from '@/types/gtm';
import { FTunnelPageBookingTypeEnum } from '@/types/tunnel';
import { FValidationErrorTypeEnum } from '@/types/validation';
import pushGTMDataLayer from './pushGTMDataLayer';
const sendGTMConfirmBookingFailed = (error, bookingType) => {
    const errors = `${error.message}: ${JSON.stringify(error)}`;
    const lowerCaseErrorMsg = error.message.toLowerCase();
    let error_type;
    if (lowerCaseErrorMsg.includes(BBookingPaymentStatusEnum.StockError) || lowerCaseErrorMsg.includes(FValidationErrorTypeEnum.SLOT_IS_FULL_PARTIAL_ERROR_MSG)) {
        error_type = FGA4ConfirmBookingErrorTypeEnum.slot_is_full;
    }
    else if (lowerCaseErrorMsg.includes('stripe') || lowerCaseErrorMsg.includes(BBookingPaymentStatusEnum.PaymentError)) {
        error_type = FGA4ConfirmBookingErrorTypeEnum.payment;
    }
    else if (lowerCaseErrorMsg.includes(BBookingPaymentStatusEnum.InternalServerError)) {
        error_type = FGA4ConfirmBookingErrorTypeEnum.internal_server_error;
    }
    else if (lowerCaseErrorMsg.includes('form')) {
        error_type = FGA4ConfirmBookingErrorTypeEnum.form_errors;
    }
    else {
        error_type = bookingType === FTunnelPageBookingTypeEnum.voucher ? FGA4ConfirmBookingErrorTypeEnum.create_gift : FGA4ConfirmBookingErrorTypeEnum.make_reservation;
    }
    pushGTMDataLayer({
        errors,
        error_type,
        event: FGTMEventEnum.confirm_booking_failed
    });
};
export default sendGTMConfirmBookingFailed;
